var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcXsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h14.25v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.797 0H9.703a1.83 1.83 0 0 0-1.826 1.75H6.373A1.83 1.83 0 0 0 4.547 0H3.453a1.83 1.83 0 0 0-1.828 1.828v.186A2.815 2.815 0 0 0 0 4.562v8.626A2.816 2.816 0 0 0 2.813 16h8.625a2.816 2.816 0 0 0 2.812-2.812V4.562c0-1.126-.666-2.1-1.625-2.548v-.186A1.83 1.83 0 0 0 10.797 0",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M1.5 6.75h11.25v6.437c0 .725-.588 1.313-1.312 1.313H2.812A1.313 1.313 0 0 1 1.5 13.187V6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M1.5 5.547v-.984c0-.725.588-1.313 1.312-1.313h.313V1.828c0-.18.147-.328.328-.328h1.094c.181 0 .328.148.328.328V3.25h4.5V1.828c0-.18.147-.328.328-.328h1.094c.181 0 .328.148.328.328V3.25h.313c.724 0 1.312.588 1.312 1.313v.984H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.5 6.75h11.25v5.437c0 .725-.588 1.313-1.312 1.313H2.812A1.313 1.313 0 0 1 1.5 12.187V6.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXsCalendar);
export default __webpack_public_path__ + "static/media/ic_xs_calendar.26aa8fe051e262dfcc8f9b08b7c86ccb.svg";
export { ForwardRef as ReactComponent };